/* =============================================================
   kit-coleira-base.js — JS COMPARTILHADO (PT-BR)
   =============================================================
   Substitui o JS duplicado em ~20 snippets (kqr-*, COLEIRA2X1-*,
   safe-4en1, guia-maos-livres, combogato). Carrega UMA vez no
   theme e cuida de:

     1. Reveal on-scroll  (.kqr-reveal, .kqr-stagger, etc.)
     2. SF Carousel        (.sf-wrap > .sf-track > .sf-slide)
        — auto-init em qualquer carousel da página, com touch,
        teclado, dots, arrows e autoplay com pause on hover.

   ============================================================
   USO no theme.liquid (head ou antes de </body>):
     <script src="{{ 'kit-coleira-base.js' | asset_url }}" defer></script>

   Após adicionar, remova os blocos <script> inline duplicados
   de cada snippet (kqr-*.liquid, COLEIRA2X1-*.liquid, etc.).
   ============================================================ */

(function () {
  'use strict';

  /* ─────────────────────────────────────────────
     1) REVEAL ON-SCROLL
     ───────────────────────────────────────────── */
  function initReveal(root) {
    var targets = (root || document).querySelectorAll(
      '.kqr-reveal, .kqr-reveal-up, .kqr-reveal-scale, .kqr-reveal-blur, .kqr-stagger'
    );
    if (!targets.length) return;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -4% 0px' });

      targets.forEach(function (el) { io.observe(el); });
    } else {
      // Fallback: força visibilidade imediatamente
      targets.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    // Failsafe: se IO não disparar em 1.2s, força in
    setTimeout(function () {
      targets.forEach(function (el) { el.classList.add('is-in'); });
    }, 1200);
  }

  /* ─────────────────────────────────────────────
     2) SF CAROUSEL — encontra TODOS .sf-wrap na página
     e inicializa cada um independentemente.
     ───────────────────────────────────────────── */
  function initSfCarousels(root) {
    var wraps = (root || document).querySelectorAll('.sf-wrap');
    wraps.forEach(function (wrap) {
      if (wrap.dataset.sfInit) return;
      wrap.dataset.sfInit = 'true';

      var track    = wrap.querySelector('.sf-track');
      var slides   = track ? track.querySelectorAll('.sf-slide') : [];
      var total    = slides.length;
      if (!track || total === 0) return;

      // Find external counter/dots/arrows that share the same container
      // (some snippets put them outside .sf-wrap)
      var container = wrap.parentElement || document;
      function sib(sel) {
        return wrap.querySelector(sel) || container.querySelector(sel);
      }
      var dotsWrap = sib('.sf-dots');
      var counter  = sib('.sf-counter');
      var btnPrev  = sib('.sf-arrow--prev');
      var btnNext  = sib('.sf-arrow--next');

      var current = 0;
      var timer   = null;
      var pct     = 100 / total;
      var AUTOPLAY_MS = 4000;

      track.style.width = (total * 100) + '%';
      slides.forEach(function (s) { s.style.flex = '0 0 ' + pct + '%'; });

      // Build dots
      if (dotsWrap) {
        dotsWrap.innerHTML = '';
        for (var i = 0; i < total; i++) {
          var d = document.createElement('button');
          d.className = 'sf-dot' + (i === 0 ? ' is-active' : '');
          d.setAttribute('aria-label', 'Slide ' + (i + 1));
          d.dataset.i = i;
          (function (idx) {
            d.addEventListener('click', function () { goTo(idx); resetAP(); });
          })(i);
          dotsWrap.appendChild(d);
        }
      }
      var dots = dotsWrap ? dotsWrap.querySelectorAll('.sf-dot') : [];

      function goTo(idx) {
        if (dots.length) dots[current].classList.remove('is-active');
        current = ((idx % total) + total) % total;
        track.style.transform = 'translateX(-' + (current * pct) + '%)';
        if (dots.length) dots[current].classList.add('is-active');
        if (counter) counter.textContent = (current + 1) + ' / ' + total;
      }
      function startAP() { clearInterval(timer); timer = setInterval(function () { goTo(current + 1); }, AUTOPLAY_MS); }
      function stopAP()  { clearInterval(timer); }
      function resetAP() { stopAP(); startAP(); }

      if (btnPrev) btnPrev.addEventListener('click', function () { goTo(current - 1); resetAP(); });
      if (btnNext) btnNext.addEventListener('click', function () { goTo(current + 1); resetAP(); });

      // Touch
      var sx = 0, sy = 0, drag = false, moved = false;
      wrap.addEventListener('touchstart', function (e) {
        sx = e.touches[0].clientX; sy = e.touches[0].clientY;
        drag = true; moved = false; stopAP();
      }, { passive: true });

      wrap.addEventListener('touchmove', function (e) {
        if (!drag) return;
        var dx = e.touches[0].clientX - sx;
        var dy = e.touches[0].clientY - sy;
        if (Math.abs(dx) > Math.abs(dy) + 8) {
          e.preventDefault();
          moved = true;
          track.style.transition = 'none';
          track.style.transform = 'translateX(-' + (current * pct - (dx / wrap.getBoundingClientRect().width) * pct) + '%)';
        }
      }, { passive: false });

      wrap.addEventListener('touchend', function (e) {
        if (!drag) return;
        drag = false;
        track.style.transition = '';
        var dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 42 && moved) {
          goTo(dx < 0 ? current + 1 : current - 1);
        } else {
          goTo(current);
        }
        startAP();
      }, { passive: true });

      // Mouse drag (desktop)
      var mStart = 0, mDrag = false, mMoved = false;
      wrap.addEventListener('mousedown', function (e) {
        mStart = e.clientX; mDrag = true; mMoved = false;
        wrap.style.cursor = 'grabbing';
        stopAP();
      });
      window.addEventListener('mousemove', function (e) {
        if (!mDrag) return;
        var dx = e.clientX - mStart;
        if (Math.abs(dx) > 6) {
          mMoved = true;
          track.style.transition = 'none';
          track.style.transform = 'translateX(-' + (current * pct - (dx / wrap.getBoundingClientRect().width) * pct) + '%)';
        }
      });
      window.addEventListener('mouseup', function (e) {
        if (!mDrag) return;
        mDrag = false;
        wrap.style.cursor = '';
        track.style.transition = '';
        var dx = e.clientX - mStart;
        if (Math.abs(dx) > 48 && mMoved) {
          goTo(dx < 0 ? current + 1 : current - 1);
        } else {
          goTo(current);
        }
        startAP();
      });

      // Keyboard
      wrap.setAttribute('tabindex', wrap.getAttribute('tabindex') || '0');
      wrap.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { goTo(current + 1); resetAP(); }
        if (e.key === 'ArrowLeft')  { goTo(current - 1); resetAP(); }
      });

      // Autoplay só quando visível
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries[0].isIntersecting ? startAP() : stopAP();
        }, { threshold: 0.3 }).observe(wrap);
      } else {
        startAP();
      }
    });
  }

  /* ─────────────────────────────────────────────
     3) IMAGE LAZY DECODING ENHANCEMENT
     Garante que toda <img> sem `loading` ganha `lazy`
     e `decoding="async"` — útil pros snippets antigos
     que esqueceram esses atributos.
     ───────────────────────────────────────────── */
  function enhanceImages(root) {
    var imgs = (root || document).querySelectorAll(
      '.kqr-feature img, .kqr-carousel img, .kqr-panel img, .kqr-diff img, ' +
      '.sf-slide img, [class^="sessao_"] img, [id^="sessao_"] img'
    );
    imgs.forEach(function (img) {
      if (!img.hasAttribute('loading')) img.setAttribute('loading', 'lazy');
      if (!img.hasAttribute('decoding')) img.setAttribute('decoding', 'async');
    });
  }

  /* ─────────────────────────────────────────────
     BOOT
     ───────────────────────────────────────────── */
  function boot() {
    initReveal(document);
    initSfCarousels(document);
    enhanceImages(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Expor pra integrações futuras (Shopify Customizer hot-reload, etc.)
  window.kqrBase = {
    initReveal: initReveal,
    initSfCarousels: initSfCarousels,
    enhanceImages: enhanceImages,
    refresh: boot,
  };

  // Re-init em mudanças do customizer
  document.addEventListener('shopify:section:load', function () { boot(); });
})();
